(() => {
  const link = document.querySelector('[data-tof-checkout]');
  if (!link || link.dataset.ready) return;
  link.dataset.ready = 'true';
  let busy = false;
  link.addEventListener('click', async event => {
    event.preventDefault();
    if (busy) return;
    const form = link.closest('form');
    const rows = [...form.querySelectorAll('[data-line-key]')];
    const inputs = rows.map(row => row.querySelector('[name="updates[]"]'));
    const updates = inputs.map(input => Number(input.value));
    const error = form.querySelector('[data-tof-cart-error]');
    error.hidden = true;
    if (updates.some(q => !Number.isSafeInteger(q) || q < 0) || updates.every(q => q === 0)) {
      error.textContent = link.dataset.error; error.hidden = false; error.focus(); return;
    }
    busy = true; link.setAttribute('aria-disabled','true');
    inputs.forEach(input => {input.readOnly=true;});
    try {
      const currentResponse = await fetch(link.dataset.root+'cart.js',{cache:'no-store',credentials:'same-origin'});
      if(!currentResponse.ok) throw Error();
      const current = await currentResponse.json();
      if(current.items.length!==rows.length || current.items.some((item,i)=>item.key!==rows[i].dataset.lineKey)) throw Error();
      const response = await fetch(link.dataset.root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
      const result = await response.json();
      if(!response.ok || !result.item_count) throw Error();
      location.assign(link.href);
    } catch (_) {
      error.textContent=link.dataset.error;error.hidden=false;error.focus();busy=false;link.removeAttribute('aria-disabled');inputs.forEach(input=>{input.readOnly=false;});
    }
  });
})();
